














import { Vue, Component } from 'vue-property-decorator'

@Component({
  mounted(this: Heatmap) {
    this.active = true
    this.$store.dispatch('requestStatusCount')

    this.tick()
  },

  destroyed(this: Heatmap) {
    this.active = false
  }
})
export default class Heatmap extends Vue {
  active = false
  blockNum = 0
  hoveredBlock: HTMLElement | null = null
  hoveredIndex = 0
  currentBlockIndex: number = -1

  get blockJSTIndexes(): number[] {
    const indexes = []
    const n = this.blockNum
    for (let i = Math.ceil((n * (24 - 9)) / 24); i < n; i++) indexes.push(i)
    for (let i = 0; i < Math.ceil((n * (24 - 9)) / 24); i++) indexes.push(i)
    return indexes
  }

  get statusCount(): number[] {
    const data = this.$store.state.statusCount
    const keys = Object.keys(data)
      .map(k => +k)
      .sort((a, b) => a - b)
    const result = []
    const widthTimeUnit = (24 * 60 * 60 * 1000) / this.blockNum

    for (let i = 0; i < this.blockNum; i++) {
      const start = widthTimeUnit * i
      const end = start + widthTimeUnit
      let count = 0
      for (let key of keys) {
        if (start <= key && key <= end) count += data[key + ''].value
        else if (end < key) break
      }
      result[i] = count
    }

    return result
  }

  get blockColor(): string[] {
    const data = this.statusCount.map(d => Math.log(d + 1))
    const max = Math.max(...data)
    const min = Math.min(...data)

    return data.map(
      d =>
        `hsl(${((max - d) / (max - min)) * 300}, ${(d / max) * 100}%, ${(d /
          max) *
          30 +
          20}%)`
    )
  }

  get infoboxTop(): number {
    if (this.hoveredBlock) {
      const top = this.hoveredBlock.getBoundingClientRect().top
      if (top + 200 > window.innerHeight) return top - 200 - 30
      else return top + 30
    } else return 0
  }

  get infoboxLeft(): number {
    if (this.hoveredBlock) {
      const left = this.hoveredBlock.getBoundingClientRect().left
      if (left + 300 > window.innerWidth) return left - 300
      else return left
    } else return 0
  }

  get infoboxTime(): number {
    return ((24 * 60 * 60 * 1000) / this.blockNum) * this.hoveredIndex
  }

  tick(): void {
    if (this.active) setTimeout(() => this.tick(), 1000)

    const container = this.$el
    const bounding = container.getBoundingClientRect()
    const num =
      Math.floor(bounding.width / 19) * Math.floor(bounding.height / 19)

    this.blockNum = num

    this.currentBlockIndex = Math.floor(
      ((Date.now() % (24 * 60 * 60 * 1000)) / (24 * 60 * 60 * 1000)) * num
    )
  }
}
